import xmlFormat from 'xml-formatter';
import moment from 'moment';

import { faBus, faShip, faWalking } from '@fortawesome/free-solid-svg-icons';

import { GeoJsonToGpx } from './convertGeoJsonToGpx';
import { callGetFeatureJson } from '../api/jsonFeatureApi';

const toFrenchString = (num) => num.toLocaleString('fr-FR');

const setOptionsGpx = (name) => {
  return {
    metadata: {
      name: `${name}`,
      author: {
        name: 'Handimap.org'
      }
    }
  };
};

export const humanLength = (length) => (
  length >= 1000 ? (
    `${toFrenchString(Math.round(length / 100) / 10)} km`
  ) : (
    `${toFrenchString(Math.round(length))} m`
  )
);

export const getFeatureGeometry = async (idFeature, idLayer) => {
  await callGetFeatureJson(idLayer, idFeature).then(
    result => {
      const { geometry } = result;
      return geometry;
    }
  ).catch(error => {
    console.log('error', error);
  });
};

export const convertGeoJsonToGpx = (geojson, label, namePosition, origin, dest) => {
  const options = setOptionsGpx(namePosition);
  const gpx = GeoJsonToGpx(geojson, options, origin, dest);
  const gpxString = new XMLSerializer().serializeToString(gpx);
  const resultGpx = xmlFormat(gpxString);

  const link = document.createElement('a');
  link.download = `${label}.gpx`;
  const blob = new Blob([resultGpx], {type: 'text/xml'});
  link.href = window.URL.createObjectURL(blob);
  link.click();
};

const toTimeDurations = totalSeconds => {
  
  const totalMinutes = Math.floor(totalSeconds / 60);

  const seconds = Math.floor(totalSeconds % 60);
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;

  return { h: hours, m: minutes, s: seconds };
};

export const getDurations = totalSeconds => {
  const { h, m } = toTimeDurations(totalSeconds);
  return `${h > 0 ? `${h}h` : ''}${m > 0 ? `${m} min` : '1min'}`;
};

export const getDurationsBetweenHours = (departure, arrival) => {
  const momentDeparture = moment(departure);
  const momentArrival = moment(arrival);
  const diff = moment.duration(momentArrival.diff(momentDeparture)).asSeconds();
  const resDiff = getDurations(diff);
  return resDiff;
};


export const convertDecimalToHexColor = (code) => {
  if (code && typeof code === 'number') {
    return `#${code.toString(16).padStart(6, '0')}`;
  } else {
    return '#000000'; 
  }
};

export const calculateLengthByType = (data) => {
  const combinedData = [];
  let currentObject = data[0];
  
  for (let i = 1; i < data.length; i++) {
    const current = data[i];
    
    if (current.mode === currentObject.mode && currentObject.mode !== 'transit') {
      currentObject.time += current.time;
      currentObject.length += current.length;
    } else {
      combinedData.push(currentObject);
      currentObject = current;
    }
  }
  combinedData.push(currentObject); // Add the last object
  return combinedData;
};

export const getIconTransport = (type) => {
  switch (type) {
    case 'bus':
      return faBus;
    case 'ferry':
      return faShip;
    default:
      return faWalking;
  }
};